module.exports = "<p>\n  upload-form works!\n</p>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/uploads/upload-form/upload-form.component.html
// module id = ./src/app/uploads/upload-form/upload-form.component.html
// module chunks = main